import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TypeSelect from './TypeSelect';
import { fetchTypes } from 'store/type/typesActions';

import { TypeCodes } from 'constants.js';

import withLoader from 'components/Shared/withLoader';

const TypeSelectWithLoader = withLoader(TypeSelect);

class TypeSelectContainer extends React.Component {
    async componentDidMount() {
        await this.props.fetchTypes();
    }

    render() {
        const { types, value, isLoading, onChange, all, error, isRequired, reclamationLiee, size } = this.props;

        var filteredTypes = reclamationLiee ? types.filter(t => t.code === TypeCodes.Interne) : types;
        
        return (
            <TypeSelectWithLoader
                isLoading={isLoading}
                types={filteredTypes}
                value={value}
                onChange={onChange}
                all={all}
                error={error}
                isRequired={isRequired}
                size={size}
            />
        );
    }
}

const mapStateToProps = state => ({
    types: state.type.types.items,
    isLoading: state.type.types.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchTypes: () => dispatch(fetchTypes())
});

TypeSelectContainer.propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    all: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    reclamationLiee: PropTypes.bool.isRequired,
    size: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(TypeSelectContainer);